import '@/i18n'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { App } from './App'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { ToastProvider } from '@/components/ui/toast'
import { qc } from '@/lib/queryClient'
import { installGlobalErrorReporters } from '@/lib/report'
// CSS 按原 index.css 顺序切分为有序 import（JS 导入序即级联序，与原单文件一致；
// 不用 @import 聚合器——它会把后置段提回文件头破坏原序）。
import './styles/fonts.css'
import './index.css'
import './styles/motion.css'
import './styles/late.css'

// Dogfood observability: window.onerror + unhandledrejection →
// POST /observability/client-events (fire-and-forget, throttled, deduped).
installGlobalErrorReporters()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={qc}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
)
